/* unplugin-vue-components disabled */import script from "./PcHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PcHeader.vue?vue&type=script&setup=true&lang=js"

import "./PcHeader.vue?vue&type=style&index=0&id=1c5b2821&scoped=true&lang=scss"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5b2821"]])

export default __exports__